<template>
  <div>
    <v-card>
        <v-card-title>
            <div>
                <div class="title">Basic Information</div>
            </div>
            
        </v-card-title>
        <v-card-text>
            <v-layout row>
            <v-flex xs12>
                <v-text-field
                label="First Name *"
                v-model="editUserData.basicInfo.fName"
                type="text"
                :rules="[rules.required]"
                ></v-text-field>
            </v-flex>
            </v-layout>
            <v-layout row>
            <v-flex xs12>
                <v-text-field
                label="Last Name *"
                v-model="editUserData.basicInfo.lName"
                type="text"
                :rules="[rules.required]"
                ></v-text-field>
            </v-flex>
            </v-layout>
            <v-layout row>
                <v-flex xs9>
                    <v-text-field
                    label="Phone *"
                    v-model="editUserData.basicInfo.phone"
                    type="phone"
                    :rules="[rules.required]"
                    ></v-text-field>
                </v-flex>
                <v-flex xs3 pl-1>
                    <v-text-field
                    label="Ext."
                    v-model="editUserData.basicInfo.phoneExt"
                    type="text"
                    ></v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row>
            <v-flex xs12>
                <v-text-field
                label="Email *"
                v-model="editUserData.basicInfo.email"
                type="email"
                :rules="emailRules"
                ></v-text-field>
            </v-flex>
            </v-layout>
            <v-layout row>
            <v-flex xs12>
                <v-select
                label="User Roles *"
                v-bind:items="roles"
                v-model="editUserData.basicInfo.roles"
                multiple
                hint=""
                persistent-hint
                :rules="[rules.required]"
                ></v-select>
                <div class="orange--text">
                    role: salessupport allows user to create/view quote for any Facilities. 
                    We can give all US Regional Managers this role.
                    <br> 
                    role: salesQuoteManager allows sales rep to do CS Rep work 
                    (for international Sales Rep). 
                    <br>
                    role:salesadmin allows user to accsss Product Catalog Admin Buttons in Settings page. 
                    Also, user must systemadmin role to access Settings page. 
                </div>
            </v-flex>
            </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    props: ['editUserData'],
    data () {
        return {
            rules: {
                required: v => !!v || "This field is required"
            },
            emailRules: [
                (v) => !!v || 'E-mail is required',
                (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
            ],

            roles: [],
        }
    },
    computed: {
        // comparePasswords () {
        //     return this.password !== this.confirmPassword ? 'Passwords do not match' : true
        // },
       
    },
    watch: {
        user (value) {
            if (value !== null && value !== undefined) {
                this.$router.push('/')
            }
        },
        'editUserData.roles': {
            handler: function (newVal, oldVal) {
                // console.log('watch editUserData changed')
                // this.checkShowLoginSection()
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('adminUser', [
            'getAllRoles'
        ]),
        checkShowLoginSection () {
            // this.showLoginSection = (this.editUserData.roles !== undefined && this.editUserData.roles.length > 0)
        },
    },
    created: async function () {
        this.roles = await this.getAllRoles();
    },
}
</script>